import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { TRANSLATIONS_ES } from './es/translations';
import { TRANSLATIONS_PT } from './pt/translations';
const resources = {
    es: {
        translation: TRANSLATIONS_ES,
    },
    pt: {
        translation: TRANSLATIONS_PT,
    },
};
const DETECTION_OPTIONS = {
    order: ['localStorage', 'navigator'],
    lookupLocalStorage: 'language',
};
const i18nInstance = i18n.createInstance();
void i18nInstance.use(LanguageDetector).use(initReactI18next).init({
    resources,
    detection: DETECTION_OPTIONS,
    fallbackLng: 'es',
    returnNull: false,
});
export default i18nInstance;
